/*
Akhila 01/30/2023 2698948956 Bug Fixed delete id issue while overRide and Reset Issue
Akhila 05/31/2023 2698948956 unsaved changes bug fixed
Ravi 05/31/2023 2698948956 changed delete popup message
*/

import React, {useState} from 'react';
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../components/TableIcons';
import {defaultRows} from '../../../../constants/ReusableTablePagination';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../constants/ReusableConstants';

export default function FormulaTable({
  selectedRows,
  setSelectedRows,
  deletedIds,
  setDeletedIds,
  fieldsDeleteIdsRef,
  handleDirty,
}) {
  const [isDelete, setIsDelete] = useState(false);
  const [deleteData, setDeleteData] = useState({});
  const columns = [
    {
      title: 'Category',
      render: (rowData) => {
        return rowData?.category === 'CL' ?
        `CL - Client` :
          rowData?.category === 'CO' ?
        `CO - Core` :
            '';
      },
      width: '1%',
    },
    {
      title: 'Repository Name',
      field: 'repositoryName',
    },
    {
      title: 'Field Name',
      field: 'fieldName',
    },

    {
      title: 'Field Type',
      field: 'fieldType',
    },
    // {
    //   title: "Repository Type",
    //   field: "repositoryType",
    // },
  ];

  const [rows, setRows] = useState(defaultRows);
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleSubmit = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const arr = [...selectedRows];
        const newData = arr.filter(
          (row) =>
            row.fieldName.concat(row.repositoryName) !==
            deleteData?.fieldName.concat(deleteData?.repositoryName),
        );
        const newDeletedIds = [...deletedIds];
        if (deleteData?.formulaFieldMapId) {
          newDeletedIds.push(deleteData?.formulaFieldMapId);
        }
        fieldsDeleteIdsRef.current = [...fieldsDeleteIdsRef.current, ...newDeletedIds];
        setDeletedIds(newDeletedIds);
        setSelectedRows(newData);
        handleDeleteClose();
        resolve();
      }, 1000);
      handleDirty(true);
    });
  };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Field"
        // value={`Are you sure you want to delete the ${deleteData?.fieldName} field from the Field List?`}
        value={`Are you sure you want to delete the ${deleteData?.fieldName} Field?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12} className="">
        {}
        <div className="custom-table global-field-table tablescroll-block">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={selectedRows}
            options={{
              toolbar: false,
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              (rowData) => {
                return {
                  icon: () => <DeleteOutlineOutlinedIcon />,
                  tooltip: 'Delete',
                  disabled: selectedRows.length === 1,
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                };
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
}
